import * as z from "zod/v4";
import { V2AdminProductIdSchema } from "./admin-products";
import {
  onboardingV2RowSchema,
  onboardingV2StatusSchema,
} from "./get-onboardings-v2";

// Hard cap on rows returned by the export RPC. When the total matching
// records exceeds this, the most-recently-updated rows are returned and the
// modal surfaces a truncation warning so the user isn't misled.
export const ONBOARDINGS_V2_MAX_EXPORT_ROWS = 10_000;

const timePeriodSchema = z.enum([
  "day",
  "week",
  "month",
  "last-month",
  "quarter",
  "all",
  "custom",
]);

const customRangeSchema = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

export const exportOnboardingsV2 = {
  name: "exportOnboardingsV2" as const,
  input: z
    .object({
      productId: z.string().optional(),
      productIds: z.array(V2AdminProductIdSchema).optional(),
      statuses: z.array(onboardingV2StatusSchema).optional(),
      searchQuery: z.string().optional(),
      hideArchived: z.boolean().default(true),
      timePeriod: timePeriodSchema,
      customRange: customRangeSchema.optional(),
    })
    .superRefine((value, ctx) => {
      if (value.timePeriod === "custom" && !value.customRange) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "customRange is required when timePeriod is custom",
          path: ["customRange"],
        });
      }
    }),
  output: z.object({ rows: z.array(onboardingV2RowSchema), total: z.number() }),
};

export type ExportOnboardingsV2Input = z.infer<
  typeof exportOnboardingsV2.input
>;
export type ExportOnboardingsV2Output = z.infer<
  typeof exportOnboardingsV2.output
>;
